import React from 'react';
import { ButtonLoading, SimpleDialog, Icons, PriceLabel, NumberToPersianWords } from 'components';
import {
  Button,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';
import { useCurrencyUnit } from 'hooks';

const DetailsImprestTransferCreditDg = (props) => {
  const {
    isConfirmModalOpen,
    handleCloseModal,
    onTransfer,
    isLoading,
    foundUser,
    amount,
    classes,
  } = props;
  const currencyText = useCurrencyUnit();
  return (
    <SimpleDialog
      title="انتقال وجه با جزئیات زیر انجام گیرد؟"
      open={isConfirmModalOpen}
      icon={<Icons icon="UserIDCard" color="#2B3990" size="25" />}
      onClose={handleCloseModal}
      actions={
        <>
          <ButtonLoading
            name="تایید"
            onClick={onTransfer}
            loading={isLoading}
            variant="contained"
            color="primary"
          />
          <Button onClick={handleCloseModal} variant="contained">
            انصراف
          </Button>
        </>
      }
    >
      <TableContainer className={classes.tableContainer}>
        <Table className={classes.table} aria-label="simple table">
          <TableBody>
            <TableRow>
              <TableCell className={classes.titleCell} component="th" scope="row">
                نام
              </TableCell>
              <TableCell>{foundUser}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.titleCell} component="th" scope="row">
                مبلغ
              </TableCell>

              <TableCell>
                <Typography className={classes.boldCell}>
                  <PriceLabel amount={amount} />
                  {currencyText}
                </Typography>
                <Typography className={classes.subTitleData}>
                  <NumberToPersianWords number={amount} />
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </SimpleDialog>
  );
};

export default DetailsImprestTransferCreditDg;
